import React, { Component }           from 'react';
import { withRouter }                 from 'react-router';
import { connect as reduxConnect }    from 'react-redux';
import { Alert, Card, CardDeck, 
         Col, Badge, Toast }          from 'react-bootstrap';
import { FaEject }                    from 'react-icons/fa';
import { FaPlug }                     from 'react-icons/fa';
import PubSub                         from 'pubsub-js';
import { ClipLoader }                 from 'react-spinners';
import { ConnectConstants }           from '../environment';
import { redirect }                   from '../../../../utils/authService'; 
import { isLoggedIn }                 from '../../../../utils/authService';
import { attributeFromToken }         from '../../../../utils/authService';
import { connectSourcesFetchData }    from '../../../../actions/connect/sources';
import { connectInstancesFetchData }  from '../../../../actions/connect/instances';
import { connectDisconnectFetchData } from '../../../../actions/connect/disconnect';
import Chat                           from './Chat';

var apiHost = ConnectConstants.WebApiHost;

class ChatCards extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      email             : '',
      name              : '',
      studentId         : '',
      chat              : false,
      chatEnabled       : false,
      anonymousAuth     : '',
      search            : '',
      sources           : [],
      filtered          : [],
      currentChatId     : {},
      allChatSessions   : {},
      interval          : 60000,
      intervalFunc      : null,
      businessHours     : {},
      outsideMessage    : '',
      outsideHours      : false,
      show              : true
    };
    
    this.handleSearchChange    = this.handleSearchChange.bind(this);
    this.handleSearchKeyDown   = this.handleSearchKeyDown.bind(this);
    this.handleLeavePage       = this.handleLeavePage.bind(this);
    this.handleRedirect        = this.handleRedirect.bind(this);
    this.subscriber            = this.subscriber.bind(this);
    this.changeChat            = this.changeChat.bind(this);
    this.search                = this.search.bind(this);
    this.sources               = this.sources.bind(this);
    this.disconnect            = this.disconnect.bind(this);
    this.login                 = this.login.bind(this);
    this.closeToast            = this.closeToast.bind(this);
    this.cardFooter            = this.cardFooter.bind(this);
    this.linkify               = this.linkify.bind(this);
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.token);
    PubSub.unsubscribe(this.tokenA);
    PubSub.unsubscribe(this.tokenB);
    PubSub.unsubscribe(this.tokenC);
    PubSub.unsubscribe(this.tokenD);
    PubSub.unsubscribe(this.tokenE);
    
    window.removeEventListener('beforeunload', this.handleLeavePage);
    if (this.state.intervalFunc) {
      window.clearInterval(this.state.intervalFunc);
    }
    
    this.handleLeavePage();
  }

  componentDidMount() {  
    this.token  = PubSub.subscribe('connect.chat.response',       this.subscriber.bind(this));
    this.tokenA = PubSub.subscribe('connect.chat.sources',        this.subscriber.bind(this));
    this.tokenB = PubSub.subscribe('connect.chat.instances',      this.subscriber.bind(this));
    this.tokenC = PubSub.subscribe('connect.chat.attributes',     this.subscriber.bind(this));
    this.tokenD = PubSub.subscribe('connect.chat.ui.chatClose',   this.subscriber.bind(this));
    this.tokenE = PubSub.subscribe('connect.chat.ui.stateChange', this.subscriber.bind(this));
    if (isLoggedIn()) {
      this.logUserData();
      this.setState({
        chat: true,
        chatEnabled: false,
        authenticated: true
      }, function() {
        this.sources();
        var intervalFunc = window.setInterval(this.sources, this.state.interval);
        this.setState({
          intervalFunc: intervalFunc
        });
      });
    }

    this.props.fetchDataInstances(apiHost);
    window.addEventListener('beforeunload', this.handleLeavePage);
  }
  
  ///////////////////
  // CHAT METHODS //
  //////////////////
  
  changeChat(element) {
    if (!isLoggedIn() && this.state.authenticated) {
      // Handle case where they are not logged in, the refresh failed, and make them re-authenticate.
      this.login();
    }
    else {
      this.setState({
        chat: true,
        chatEnabled: true,
        currentChatId: element
      });
    }
    
    return false;
  }
  
  subscriber(msg, data) {
    if (msg === "connect.chat.response") {
      let copiedSessions = Object.assign({}, this.state.allChatSessions);
      for(var propertyName in copiedSessions) {
        if (copiedSessions[propertyName]) {
          copiedSessions[propertyName].ActiveChat = false;
        }
      }
      
      copiedSessions[this.state.currentChatId.Id] = {
        MetaData    : this.state.currentChatId,
        MissedChats : 0,
        Connected   : true,
        ActiveChat  : true,
        ContactId   : data.startChatResult.ContactId            
      };
      
      this.setState({
        allChatSessions : copiedSessions,
        anonymousAuth   : data.attributes.Authentication
      });
      
      PubSub.publish('feedback.attributes', {
        anonymousAuth: data.attributes.Authentication 
      });
    }
    else if (msg === "connect.chat.sources") {
      var filtered = data;
      if (this.state.filtered.length > 0 || (this.state.filtered.length === 0 && this.state.search))
      {
        console.log('using original source data and checking for filter differences');
        filtered = [...this.state.filtered];
        for (let i = 0; i < filtered.length; i++) {
          let f = filtered[i];
          let d = data.find(o => o.Id === f.Id);
          if (!d) {
            console.log('data missing, resetting view and search');
            filtered = data;
            this.setState({
              search: ''  
            });
            
            break;
          }
          
          Object.assign(f, d);
        }
        
        for (let i = 0; i < data.length; i++) {
          let f = data[i];
          let d = filtered.find(o => o.Id === f.Id);
          if (!d) {
            console.log('data missing, resetting view and search');
            filtered = data;
            this.setState({
              search: ''  
            });
            
            break;
          }
        }
      }
      else {
        console.log('using new source data');
      }
      
      var online  = filtered.filter(obj => obj.Online);
      var offline = filtered.filter(obj => !obj.Online);
      
      online  = online.sort( (a,b) => (a.Title > b.Title) ? 1 : -1);
      offline = offline.sort((a,b) => (a.Title > b.Title) ? 1 : -1);
      
      filtered = online.concat(offline);
      
      this.setState({
        sources: data,
        filtered: filtered
      }, function() {
        this.handleRedirect();
      });
    }
    else if (msg === "connect.chat.instances") {
      this.setState({
        businessHours: data.BusinessHours,
        outsideMessage: data.BusinessHoursMessage
      }, function() {
        this.sources();
      });
    }
    else if (msg === "connect.chat.attributes") {
      if (data && data.anonymousAuth) {
        this.setState({
          anonymousAuth: data.anonymousAuth
        });
      }
    }
    else if (msg === "connect.chat.ui.chatClose") {
      this.setState({
        chatEnabled: false
      });
    }
    else if (msg === "connect.chat.ui.stateChange") {
      if (data.cards && !isLoggedIn()) {
        this.setState({
          chat        : true,
          chatEnabled : false,
          email       : data.email,
          name        : data.name,
          studentId   : data.studentId
        }, function() {
          this.handleRedirect();
        });
      }
      else if (data.hasOwnProperty('chatSession')) {
        let copiedSessions = Object.assign({}, this.state.allChatSessions);
        copiedSessions[this.state.currentChatId.Id].ChatSession = data.chatSession;
        this.setState({
          allChatSessions : copiedSessions,
          chatSession     : data.chatSession
        });
      }
    }
  }
  
  sources() {
    this.props.fetchDataSources(apiHost);
    if (this.state.businessHours) {
      var date    = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Boise' }));
      var days    = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var name    = days[date.getDay()];
      var day     = this.state.businessHours[name];
      var hours   = date.getHours();
      var outside = false;
      console.log('today is ' + name + ' at hour ' + hours);
      
      if (!day) {
        return;
      }
      
      if (!day.Active || !day.Start || !day.End) {
        outside = true
      }
      else {
        if (!(hours >= day.Start && hours < day.End)) {
          outside = true;
        }
      }
      
      this.setState({
        outsideHours: outside
      });
    }
  }
  
  disconnect(id) {
    if (this.state.allChatSessions[id]) {
      console.log('trying disconnect');
      
      let copiedSessions = Object.assign({}, this.state.allChatSessions);
      copiedSessions[id] = null;
      
      var currentChatId = this.state.currentChatId;
      var allSession    = this.state.allChatSessions[id];
      var chatSession   = this.state.chatSession;
      var messages      = this.state.messages;
      if (currentChatId && currentChatId.Id === id) {
        console.log('disconnect: purging current chat');
        currentChatId = {};
        chatSession   = null;
      }
      else {
        console.log('disconnect: keeping current chat intact');
      }
      
      this.props.fetchDisconnect(apiHost, allSession.MetaData.ConnectInstanceId, allSession.MetaData.ConnectFlowId, allSession.ContactId, this.state.email);
      this.setState({
        allChatSessions : copiedSessions,
        currentChatId   : currentChatId,
        chatSession     : chatSession,
        messages        : messages,
        chat            : true
      });

      if (this.state.allChatSessions[id] && this.state.allChatSessions[id].ChatSession) {      
        this.state.allChatSessions[id].ChatSession.disconnectParticipant();
      }
    }
  }
  
  ////////////////////////
  // KEY/HELPER METHODS //
  ////////////////////////
  
  login() {
    redirect(window.location.hash.replace("#/", ""));
  }
  
  logUserData() {
    if (isLoggedIn()) {
      console.log('role: ');
      console.log(JSON.stringify(attributeFromToken('role')));
    }
  }
  
  handleRedirect() {
    const search = window.location.hash;
    const hashes = search.slice(search.indexOf('?') + 1).split('&');
    const params = {};
    hashes.map(hash => {
      const [key, val] = hash.split('=');
      params[key.toLowerCase()] = decodeURIComponent(val);
      return params;
    });
    
    var chat = params['chat'];
    console.log('chat query = ' + chat);
    console.log('source length === ' + this.state.sources.length);
    
    if (chat && this.state.sources.length > 0 && this.state.chat) {      
      var element = this.state.sources.filter(e => e.Id === chat);
      console.log(JSON.stringify(element));
      if (element.length === 1) {
        this.changeChat(element[0]);  
      }
      
      window.history.pushState("", "", '/#/connect');
    }
  }
  
  search() {
    var filtered = [];
    var search   = this.state.search.toLowerCase();
    this.state.sources.forEach(element => {
      if (element.Title.toLowerCase().includes(search) ||
          element.Description.toLowerCase().includes(search) ||
          element.Alt.toLowerCase().includes(search) ||
          element.Id.toLowerCase().includes(search)) {
        filtered.push(element);
      }
    });
    
    this.setState({
      filtered: filtered
    });
  }
  
  handleSearchChange(e) {
    this.setState({
      search: e.target.value
      },
      function() {
        this.search();
    });
  }
   
  handleSearchKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      this.search();
    }
  }
  
  handleLeavePage(e) {
    const keys = Object.keys(this.state.allChatSessions);
    for (const key of keys) {
      var allSession = this.state.allChatSessions[key];
      if (allSession && allSession.ChatSession) {
        allSession.ChatSession.sendEvent({ contentType: 'application/vnd.amazonaws.connect.event.participant.left' });  
      }
    }
  }
  
  closeToast() {
    this.setState({
      show: false
    });
  }
  
  cardFooter(element) {
    if (element.Contact) {
      let link    = null;
      let phone   = null;
      let linkify = null;
      if (element.Contact.Title) {
        if (element.Contact.Href) {
          linkify = this.linkify(element.Contact.Href);
          link = <a href={linkify.Link} target={linkify.Target}>{element.Contact.Title}</a>;
        }
        else {
          link = <span>{element.Contact.Title} &nbsp;</span>;
        }
      }
      else {
        if (element.Contact.Href) {
          linkify = this.linkify(element.Contact.Href);
          link = <a href={linkify.Link} target={linkify.Target}>{element.Online ? 'Online' : 'Offline'}</a>;
        }
        else {
          link = <span>{element.Online ? 'Online' : 'Offline'} &nbsp;</span>;
        }
      }
      
      if (element.Contact.Phone) {
        phone = 
          <span>
            &nbsp; | &nbsp;
            <a href={'tel:' + element.Contact.Phone}>{element.Contact.Phone}</a>
          </span>;
      }
      
      return <span>{link}{phone}</span>;

    }
    else {
      if (element.Online) {
        return <span>Online &nbsp;</span>;
      }
      else {
        return <span>Offline &nbsp;</span>;
      }
    }
  }
  
  linkify(link) {
    const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var target   = '_blank';
    if (regexp.test(link)) {
      target = '';
      if (!link.startsWith('mailto:')) {
        link = 'mailto:' + link;
      }
    }
    
    return {
      Link: link,
      Target: target
    };
  }

  render() {
    return (
      <div>
        { this.state.chat ?
          <div id="chat-frame">
            { this.state.outsideHours ?
              <Alert variant='warning' style={{ marginBottom: '20px' }}>
              { this.state.outsideMessage }
              </Alert>
              :
              <span />
            }
            
            { !this.props.instancesIsLoading && !this.props.instancesHasErrored && this.props.connectInstances.Banner ?
              <div
                aria-live="polite"
                aria-atomic="true"
              >
                <Toast 
                  show={this.state.show}
                  onClose={this.closeToast}
                  style={{
                    padding: '.8rem',
                    width: '100%',
                    maxWidth: 'inherit',
                    marginBottom: '20px'
                  }}
                >
                  <Toast.Header style={{ fontSize: '16px', fontFamily: 'inherit' }}>
                    <strong className="mr-auto">{this.props.connectInstances.Banner.Title}</strong>
                  </Toast.Header>
                  <Toast.Body style={{ fontSize: '14px', fontWeight: 500, fontFamily: 'inherit', color: 'black' }}>{this.props.connectInstances.Banner.Body}</Toast.Body>
                </Toast>
              </div>
              :
              <span></span>
            }
            <div>
              <div className="row">
                <div className="col-xs-6">
                  <h2>
                    Live Chat
                  </h2>
                </div>
                <div className="col-xs-6">
                  <label className='float-right'>
                    Search: &nbsp;
                    <input type="text" className="search-bar" value={this.state.search} onChange={this.handleSearchChange} onKeyDown={this.handleSearchKeyDown}></input>
                  </label>
                </div>
              </div> 
            </div>
            <CardDeck style={{ margin: 0 }}>
              { this.state.filtered.length === 0 && this.props.sourcesIsLoading && !this.state.search ?
                <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
                  <ClipLoader
                    color={'#072659'} 
                    loading={this.props.sourcesIsLoading} 
                  />
                </div>
                :
                this.state.filtered.map((element, index) => (
                  <Col sm='4' key={index} style={{ margin: '0 0 20px 0' }}>
                    <Card className='h-100' style={{ margin: '0 0 20px 0' }}>
                      <Card.Body>
                        <a className='bronco-talk-cards' onClick={() => this.changeChat(element)} href="/#/connect">
                          <h3 style={{ color: '#0033A0', display: 'inline' }}>{element.Title}</h3>
                        </a>
                        {
                          this.state.allChatSessions[element.Id] && this.state.allChatSessions[element.Id].ActiveChat ?
                          <FaPlug title='Current active chat' style={{ marginTop: '-5px', marginLeft: '5px' }} />
                          :
                          <span />
                        }
                        &nbsp;
                        {
                          element.Online ? 
                          <Badge title='Online' variant="success">Online</Badge>
                          :
                          <Badge title='Offline' variant="danger">Offline</Badge>
                        }
                        <div className='underline'>
                          <h4 style={{ lineHeight: '1.4', marginTop: '5px' }} >
                            <a className='change-chat-click' onClick={() => this.changeChat(element)} href="/#/connect">
                              {element.Description}
                            </a>
                          </h4>
                        </div>
                      </Card.Body>
                      <Card.Footer>
                        <small className="text">
                          { this.cardFooter(element) }
                          {
                            this.state.allChatSessions[element.Id] && this.state.allChatSessions[element.Id].Connected ?
                            <span>
                              &nbsp; | &nbsp;
                              <a href="/#/connect" title='Connected, click to disconnect' onClick={() => this.disconnect(element.Id)}>
                                Click here to end chat session
                                <FaEject style={{ marginTop: '-5px', marginLeft: '5px' }} />
                              </a>
                            </span>
                            :
                            <span />
                          }
                        </small>
                      </Card.Footer>
                    </Card>
                  </Col>
                ))
              }
              { this.state.filtered.length === 0 && this.state.search ?
                <Alert variant='warning' style={{ marginBottom: '20px', width: '100%' }}>
                  No results matched those keywords, please try again.
                </Alert>
                :
                <span />
              }
            </CardDeck>
          </div>
          :
          <span></span>
        }
        { this.state.chatEnabled ?
          <Chat currentChatId={this.state.currentChatId} 
                disconnect={this.disconnect} 
                email={this.state.email} 
                name={this.state.name} 
                studentId={this.state.studentId}
                anonymousAuth={this.state.anonymousAuth}
          />
          :
          <span></span>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    connectInstances: state.connect.connectInstances.connectInstances,
    instancesHasErrored: state.connect.connectInstances.connectInstancesHasErrored,
    instancesIsLoading: state.connect.connectInstances.connectInstancesIsLoading,
    connectSources: state.connect.connectSources.connectSources,
    sourcesHasErrored: state.connect.connectSources.connectSourcesHasErrored,
    sourcesIsLoading: state.connect.connectSources.connectSourcesIsLoading,
    connectDisconnect: state.connect.connectDisconnect.connectDisconnect,
    disconnectHasErrored: state.connect.connectDisconnect.connectDisconnectHasErrored,
    disconnectIsLoading: state.connect.connectDisconnect.connectDisconnectIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataInstances: (host)                                           => dispatch(connectInstancesFetchData(host)),
    fetchDisconnect:    (host, instanceId, flowId, contactId, userName)  => dispatch(connectDisconnectFetchData(host, instanceId, flowId, contactId, userName)),
    fetchDataSources:   (host)                                           => dispatch(connectSourcesFetchData(host)),
  };
};

export default withRouter(reduxConnect(mapStateToProps, mapDispatchToProps)(ChatCards));
